import { Component, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, } from '@angular/material/dialog';

import { PostulacionesService } from '../../services/postulaciones/postulaciones.service';
import Swal from 'sweetalert2';
import { AlertDialogComponent } from '../alert-dialog/alert-dialog.component';
import { DialogTipoRechazo } from '../common/postulacion-rechazar.component';
import { ConfirmationDialog } from '../confirmation-dialog/confirmation-dialog.component';
import { environment } from '../../../environments/environment';
import { isNullOrUndefined } from 'util';
import { isNull } from 'util';
export interface DialogData
{
    archivo: any;
    idPostulacion: any;
    beneficiario: string;
    etapaEscolar: string;
    fechaCertificado: any;
    postulantes: any;
    carga: boolean;
    cursos: any;
    deshabilitado: boolean;
    presionaEditar: boolean;
    recarga: boolean;
    email: string;
    nombreCompleto: string;
    mostrarEditar: string;
    rol: string;
    disponiblePago:any;
    mostrarAprobarButton:any;
    diasDiferencia:any;
}

@Component({
    selector: 'dialog-overview-example-dialog',
    templateUrl: '../../pages/postulaciones/postulacion-escolaridad-validar.html',
    styleUrls: ['../../pages/postulaciones/postulaciones.component.css'],
})
export class DialogEditPostulacionEscolaridad
{
    constructor( public dialogRef: MatDialogRef<DialogEditPostulacionEscolaridad>,
                 private postulacionesService: PostulacionesService,
                 @Inject(MAT_DIALOG_DATA) public data: DialogData, private dialog: MatDialog, )
    {
        this.data.recarga = false
        this.data.rol = localStorage.getItem('rol')
    }

    onRechazarClick(): void
    {
        let vm = this

    
        let dataRechazo: any =
        {
            idPostulacion: this.data.idPostulacion, tiposRechazo: [], tipoRechazo: '', email: this.data.email,
            nombreCompleto: this.data.nombreCompleto, nombreProducto: 'ESCOLARIDAD'
        }

        this.postulacionesService.motivoRechazo(2).then ( rechazos => { dataRechazo.tiposRechazo = rechazos
        } )
        .catch ( error => {

          console.log(error)
        } );

        const dialogRechazo = this.dialog.open(DialogTipoRechazo, { width: '50%', data: dataRechazo })

        dialogRechazo.afterClosed().subscribe( () =>
        {

            vm.data.recarga = true
            vm.dialogRef.close()
        })
    }

    onAprobarClick(idCarga: any,idUsuario:any): void
    {  
       
        let titular = true
        let rut=''
        let idUsuarioSesion = localStorage.getItem("idUsuario")
        if(!isNullOrUndefined(this.data.postulantes) && !isNullOrUndefined(this.data.postulantes[0].tipoCarga)){
            rut=this.data.postulantes[0].rut
            titular=false
            if(this.data.postulantes.length >0){
                for (let i = 0; i < this.data.postulantes.length; i++) {
                    if(idCarga== this.data.postulantes[i].id){
                        rut=this.data.postulantes[i].rut
                    }
                } 
            }
            
        }else{
            let limpiarRut=this.data.beneficiario.split("(");
            let obtenerRut= limpiarRut[1].split("-");
            rut= obtenerRut[0]
        }
              

        let vm = this
        let fechaIngresada = new Date(this.data.fechaCertificado + 'T00:00')

        let fechaMinima = new Date()
        fechaMinima.setDate(fechaMinima.getDate() - this.data.diasDiferencia)
        
       
        this.postulacionesService.sinPostulacionesVigentes(2, rut, titular).then
        (
            response =>
            {
               if(Object.values(response).length >1){                
                    vm.openAlertDialog('El rut ya tiene una solicitud de Escolaridad ingresada, favor revisar.', 'btn-danger')
                    Swal.close();
                    return
               }    
               if(fechaIngresada < fechaMinima || fechaIngresada > new Date())
               {
                   Swal.close();
                   this.openAlertDialog('La fecha de certificado ingresada no cumple con los estándares establecidos. Favor revisar.', 'btn-dark')
                   
               }else{
                   const dialogRef = this.dialog.open(ConfirmationDialog, {
                       data: { message: '¿Esta seguro de aprobar la postulación?', buttonText: { ok: 'Si', cancel: 'No' } }
                   })
           
                   dialogRef.afterClosed().subscribe((confirmed: boolean) =>
                   {
                       if (confirmed)
                       {
                         Swal.fire({
                           allowOutsideClick:false,
                           icon:'info',
                           text:'Cargando...'
                         });
                         Swal.showLoading();
                           vm.postulacionesService.cambiarEstadoPostulacion(vm.data.idPostulacion, "DISPONIBLE PARA PAGO",idUsuarioSesion).then
                           (
                               () =>
                               {
                                   vm.data.recarga = true
                                   vm.dialogRef.close()
                                   Swal.close();
                                   vm.openAlertDialog('La postulación se ha aprobado exitosamente.', 'btn-success')
                               }
                           )
                           .catch
                           (
                               error =>
                               {
                                   Swal.close();
                                   console.log(error)
                                   vm.dialogRef.close()
                                   vm.openAlertDialog('La postulación no se ha podido aprobar.', 'btn-danger')
                               }
                           )
                       }
                   })
               }
               
            }
        )
        .catch
        (
            () =>
            {
                if(fechaIngresada < fechaMinima || fechaIngresada > new Date())
                {
                    Swal.close();
                    this.openAlertDialog('La fecha de certificado ingresada no cumple con los estándares establecidos. Favor revisar.', 'btn-dark')
                    
                }else{
                    const dialogRef = this.dialog.open(ConfirmationDialog, {
                        data: { message: '¿Esta seguro de aprobar la postulación?', buttonText: { ok: 'Si', cancel: 'No' } }
                    })
            
                    dialogRef.afterClosed().subscribe((confirmed: boolean) =>
                    {
                        if (confirmed)
                        {
                          Swal.fire({
                            allowOutsideClick:false,
                            icon:'info',
                            text:'Cargando...'
                          });
                          Swal.showLoading();
                            vm.postulacionesService.cambiarEstadoPostulacion(vm.data.idPostulacion, "DISPONIBLE PARA PAGO",idUsuarioSesion).then
                            (
                                () =>
                                {
                                    vm.data.recarga = true
                                    vm.dialogRef.close()
                                    Swal.close();
                                    vm.openAlertDialog('La postulación se ha aprobado exitosamente.', 'btn-success')
                                }
                            )
                            .catch
                            (
                                error =>
                                {
                                    Swal.close();
                                    console.log(error)
                                    vm.dialogRef.close()
                                    vm.openAlertDialog('La postulación no se ha podido aprobar.', 'btn-danger')
                                }
                            )
                        }
                    })
                }     
           
            }
        )
     
    }

    onEditarClick(): void
    {
        this.data.deshabilitado = false
        this.data.presionaEditar = true
    }

    onCancelarClick(): void { this.dialogRef.close() }
    /*
    onDescargarArchivoClick(): void
    {
        if(this.data.archivo){
            const byteCharacters = atob(this.data.archivo.archivo.split(',')[1])
            const byteNumbers = new Array(byteCharacters.length)

            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i)
            }
            const byteArray = new Uint8Array(byteNumbers)
            const blob = new Blob([byteArray], {type: this.data.archivo.extension})

            var fileURL = URL.createObjectURL(blob)
            window.open(fileURL)

        }else{
            let vm = this
            Swal.close();
            vm.openAlertDialog('El archivo no se encuentra disponible.', 'btn-danger')

        }
    }
    */
    onDescargarArchivosClick(postulacionId: any)
    {   
        let vm = this
     
        vm.postulacionesService.traeArchivos(postulacionId).then
        (
            (archivos: any) =>
            {                
                archivos.forEach( archivo => {
                    var fileURL=`${environment.urlBlob}/${archivo.url}`    
                    window.open(fileURL,'_blank')                     
                })  
               
            }
        )
        .catch
        (
            error =>
            {
                console.log(error)
                vm.openAlertDialog('Ha ocurrido un error para visualizar el archivo.', 'btn-danger')
            }
        )
    }

    onGuardarClick(idCarga: any,idUsuario:any): void
    {
        let vm = this
        let idUsuarioSesion = localStorage.getItem("idUsuario")
        let fecha = this.data.fechaCertificado.split('-')
        let fechaFormateada = fecha[2] + '-' + fecha[1] + '-' + fecha[0]
        let fechaIngresada = new Date(this.data.fechaCertificado + 'T00:00')

        let fechaMinima = new Date()
        fechaMinima.setDate(fechaMinima.getDate() - this.data.diasDiferencia)

        Swal.fire({
          allowOutsideClick:false,
          icon:'info',
          text:'Cargando...'
        });
        Swal.showLoading();
        

        if(fechaIngresada < fechaMinima || fechaIngresada > new Date())
        {
            Swal.close();
            this.openAlertDialog('La fecha de certificado ingresada no cumple con los estándares establecidos. Favor revisar.', 'btn-dark')
            
        }else{
            this.postulacionesService.editaPostulacionEscolaridad(this.data.idPostulacion, idCarga, fechaFormateada, this.data.etapaEscolar,idUsuario,idUsuarioSesion).then
            (
                () =>
                {
                    vm.data.recarga = true
                    vm.dialogRef.close()
                    Swal.close();
                    vm.openAlertDialog('La postulación se ha guardado exitosamente.', 'btn-success')
                }
            )
            .catch
            (
                (error: any) =>
                {
                    vm.dialogRef.close()
                    console.log(error)
                    Swal.close();
                    vm.openAlertDialog('La postulación no se ha logrado guardar.', 'btn-danger')
                }
            )
        }
    }

    openAlertDialog(mensaje: string, clase: string)
    {
        this.dialog.open(AlertDialogComponent, {
            data: { message: mensaje, clase: clase, buttonText: { cancel: 'Listo!' }, }
        })
    }
}
